export default (instanceId, context) => {
  if (context?.managers) {
    return context.managers.find(entry => entry.instanceId === instanceId);
  }
  return null;
};